import axios from "../../../common/utils/axios";
import KitService from "../../services/kit/KitService";

export default {
    state: {
        searchValue: "",
        category: { id: 0, name: "" },
        searchKits: [],
        is_boutique: false
    },
    getters: {
        searchValue: (state) => {
            return state.searchValue;
        },
        category: (state) => {
            return state.category;
        },
        searchKits: (state) => {
            return state.searchKits;
        },
        is_boutique: (state) =>{
            return state.is_boutique
        },
    },
    mutations: {
        search(state, searchValue, category) {
            state.searchValue = searchValue;
            state.category = category;
        },
        category(state, category) {
            state.category = category;
        },
        searchKits(state, kits) {
            state.searchKits = kits;
        },
        setIsBoutique(state,value)
        {
            state.is_boutique = value
        },
    },
    actions: {
        getKitsBySearch: async(context, data) => {
            var kitService = new KitService();
            var result = await kitService.deepSearch(data);
            context.commit('searchKits', result.data.data.kits.data)
            context.commit('addToTranslations', result.data.data.translations)
            return result;

        },
    },
};